import EmailVerificationCheckpoint from './components/EmailVerificationCheckpoint';

import { IdempotencyProviderWithFeatureRegistry } from '../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';

const EmailVerificationCheckpointApp = () => (
  <IdempotencyProviderWithFeatureRegistry featureName="emailVerificationCheckpoint">
    <EmailVerificationCheckpoint />
  </IdempotencyProviderWithFeatureRegistry>
);

export default EmailVerificationCheckpointApp;
